// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex';
import components from './components';

/* eslint-disable */
(function(f,b){if(!b.__SV){var e,g,i,h;window.mixpanel=b;b._i=[];b.init=function(e,f,c){function g(a,d){var b=d.split(".");2==b.length&&(a=a[b[0]],d=b[1]);a[d]=function(){a.push([d].concat(Array.prototype.slice.call(arguments,0)))}}var a=b;"undefined"!==typeof c?a=b[c]=[]:c="mixpanel";a.people=a.people||[];a.toString=function(a){var d="mixpanel";"mixpanel"!==c&&(d+="."+c);a||(d+=" (stub)");return d};a.people.toString=function(){return a.toString(1)+".people (stub)"};i="disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" ");
for(h=0;h<i.length;h++)g(a,i[h]);var j="set set_once union unset remove delete".split(" ");a.get_group=function(){function b(c){d[c]=function(){call2_args=arguments;call2=[c].concat(Array.prototype.slice.call(call2_args,0));a.push([e,call2])}}for(var d={},e=["get_group"].concat(Array.prototype.slice.call(arguments,0)),c=0;c<j.length;c++)b(j[c]);return d};b._i.push([e,f,c])};b.__SV=1.2;e=f.createElement("script");e.type="text/javascript";e.async=!0;e.src="undefined"!==typeof MIXPANEL_CUSTOM_LIB_URL?
MIXPANEL_CUSTOM_LIB_URL:"file:"===f.location.protocol&&"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//)?"https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js":"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";g=f.getElementsByTagName("script")[0];g.parentNode.insertBefore(e,g)}})(document,window.mixpanel||[]);
mixpanel.init('caf3b9431cda4d7c0a6a40e869daef79');
/* eslint-disable */

Vue.prototype.$trackEvent = function(type, userInfo) {
  if (window.mixpanel) {
    window.mixpanel.identify(userInfo.userId);
    window.mixpanel.people.set({ 'User Id': userInfo.userId, 'Email': userInfo.email })
    window.mixpanel.track(type)
  }
};

// 全局无障碍焦点控制对象
Vue.prototype.$A11yFocus = {
  lock(modalSelector, firstActiveSelector) {
    this.unlock();
    
    Vue.nextTick(() => {
      const modal = document.querySelector(modalSelector);
      if (!modal) return;

      const firstBtn = modal.querySelector(firstActiveSelector || 'button, [tabindex="0"]');
      if (firstBtn) firstBtn.focus();

      this._listener = (e) => {
        if (e.key !== 'Tab') return;
        
        const focusables = modal.querySelectorAll('button, [tabindex="0"], a, input, select');
        if (focusables.length === 0) return;
        
        const firstEl = focusables[0];
        const lastEl = focusables[focusables.length - 1];

        if (e.shiftKey) { // Shift + Tab 反向
          if (document.activeElement === firstEl) {
            lastEl.focus();
            e.preventDefault();
          }
        } else { // Tab 正向
          if (document.activeElement === lastEl) {
            firstEl.focus();
            e.preventDefault();
          }
        }
      };

      document.addEventListener('keydown', this._listener);
    });
  },

  unlock() {
    if (this._listener) {
      document.removeEventListener('keydown', this._listener);
      this._listener = null;
    }
  }
};

Vue.config.productionTip = false

window.siderBarTabs = [{
  label: 'Home',
  tabindex: 0,
  iconName: 'home',
  popupInfo: {
    iconName: 'popup-home',
    description: 'This is your homepage. In here you can find a summary of your pending applications and programs.',
    btnText: 'Next'
  },
  routerPath: '/'
}, {
  label: 'My Apps',
  tabindex: 0,
  iconName: 'pending-apps',
  popupInfo: {
    iconName: 'popup-pending-apps',
    description: 'All your pending applications will be located here. You can keep track of your application.',
    btnText: 'Next'
  },
  routerPath: '/pendingApps'
}, {
  label: 'Active Programs',
  tabindex: 0,
  iconName: 'active-programs',
  popupInfo: {
    iconName: 'popup-active-programs',
    description: 'Once you have a program with us you will be able to track it here.',
    btnText: 'Next'
  },
  routerPath: '/activePrograms'
}, {
  label: 'Closed Programs',
  tabindex: 0,
  iconName: 'closed-programs',
  popupInfo: {
    iconName: 'popup-closed-programs',
    description: 'You can find information about past programs in this page. ',
    btnText: 'Close'
  },
  routerPath: '/closedPrograms'
}, {
  label: 'Resources',
  tabindex: 0,
  iconName: 'resources',
  routerPath: '/resources'
}];

Vue.use(components);

/* eslint-disable no-new */
new Vue({
  el: '#NCAHome',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js